import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const SUPPORTED_LANGS = ['es', 'en'];

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    // Saved choice wins; otherwise the browser language when supported; else Spanish.
    const saved = localStorage.getItem('uiLang');
    const browser = (navigator.language || 'es').slice(0, 2).toLowerCase();
    const lang = SUPPORTED_LANGS.includes(saved || '') ? saved! : (SUPPORTED_LANGS.includes(browser) ? browser : 'es');
    this.translate.setDefaultLang('es');
    this.translate.use(lang);
  }
}
